module.exports = __webpack_public_path__ + "media/mypage/images/sparkle-fluid-icon-150x150-090f12d099c02efe4713d4c2d9081dc7.png";